import React from 'react';

import { SectionTitle } from '@components/SideFeedItems/SectionTitle';

import { OrgChartCompanyQuickFactsProps } from './interfaces';

const OrgChartCompanyQuickFacts = ({ quickFacts }: OrgChartCompanyQuickFactsProps) => {
  return (
    <div className="mb-64">
      <SectionTitle title="Quick Facts" />
      {quickFacts.map((fact, index) => (
        <div key={index}>
          <p className="font-suisse-neue">{fact}</p>
        </div>
      ))}
    </div>
  );
};

export default OrgChartCompanyQuickFacts;
